import { call, put, takeEvery } from "redux-saga/effects";
import { config } from "../../../config/global";
import { preSelectMealRequest, preSelectMealSuccess, preSelectMealFailure } from "../slice/preSelectMealSlice";
import api from "../../../config/api";
import i18n from "../../../i18n";
const PRESELECT_API_URL = config.PRESELECT_MEAL;
const preSelectData = async payload => {
  const data = {
    headers: {
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "accessToken",
      "Accept-Language": `${i18n.language === "th-th" ? "TH" : "EN"}`
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.post(PRESELECT_API_URL, payload, data);
  return response;
};
function* fetchPreSelectMeal(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(preSelectData, payload);
    yield put(preSelectMealSuccess(response));
  } catch (error) {
    yield put(preSelectMealFailure(error?.response));
  }
}
export function* watchPreSelectMeal() {
  yield takeEvery(preSelectMealRequest.type, fetchPreSelectMeal);
}